<template>
  <section id="mkgest" class="hw-section hw-product">
    <div class="hw-container">
      <div class="hw-product-panel">
        <div>
          <p class="hw-kicker">Produto</p>
          <h2 class="hw-title">Plataforma MKGest</h2>
          <p class="hw-lead">
            Plataforma de gestão desenvolvida especificamente para personal trainers que fazem acompanhamento online.
            O MKGest permite criar e gerir planos de treino e nutrição totalmente adaptados a cada cliente.
          </p>
          <ul class="hw-bullets">
            <li>Planos de treino e nutrição personalizados</li>
            <li>Aplicação móvel com a marca do personal trainer</li>
            <li>Acompanhamento online dos clientes, do início ao fim</li>
          </ul>
          <div class="hw-hero-actions">
            <a class="hw-btn hw-btn-primary" href="https://mkgest.com" target="_blank" rel="noopener noreferrer">
              Visitar mkgest.com
            </a>
          </div>
        </div>
        <aside class="hw-product-card">
          <img src="@/assets/img/mkgest.jpg" alt="MKGest" />
          <p class="hw-kicker">Marca branca</p>
          <h3 class="hw-title" style="font-size: 28px;">A vossa marca. A nossa engenharia.</h3>
          <p class="hw-lead">
            Cada personal trainer recebe uma experiência digital com a sua identidade,
            para os clientes treinarem num produto que parece, e é, dele.
          </p>
        </aside>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "MKGest",
};
</script>
